
import React from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { CardContent } from '@/components/ui/card';
import { Activity } from 'lucide-react';

const GasConsumptionKpi = () => {
  return (
    <AnimatedCard 
      animation="fade-up" 
      delay={100}
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardContent className="p-6 flex flex-col items-center">
        <div className="bg-amber-100 dark:bg-amber-900/20 p-3 rounded-full mb-4">
          <Activity className="h-6 w-6 text-amber-600" />
        </div>
        <h3 className="text-xl font-medium text-gray-900 dark:text-gray-100">Monthly Consumption</h3>
        <p className="text-3xl font-bold mt-2 text-amber-600">1,850 m³</p>
        <p className="text-sm text-green-600 mt-1 flex items-center">
          <span>↓ 1.5% from last month</span>
        </p>
      </CardContent>
    </AnimatedCard>
  );
};

export default GasConsumptionKpi;
